var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1200px",
    height: "1200px",
    viewBox: "0 0 1200 1200",
    enableBackground: "new 0 0 1200 1200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1139.363,610.631c0,297.904-241.465,539.369-539.369,539.369c-297.881,0-539.357-241.465-539.357-539.369 c0-297.886,241.476-539.363,539.357-539.363C897.898,71.269,1139.363,312.745,1139.363,610.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0090B8",
    d: "M1139.363,589.357c0,297.915-241.465,539.374-539.369,539.374c-297.881,0-539.357-241.459-539.357-539.374 C60.637,291.471,302.113,50,599.994,50C897.898,50,1139.363,291.471,1139.363,589.357z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M593.834,740.028c12.176,19.315,30.428,19.315,56.81,0c18.284,46.36,101.482,200.943,101.482,200.943 s-54.037,21.949-131.157-32.137c-49.925-35.022-149.448-140.305-208.448-288.042c-32.11-80.429-42.365-168.07-42.365-267.526 c2.031-86.943,39.044-111.731,77.59-123.303l68.979,218.304c0,0-48.192,15.784-27.904,77.613 C488.822,525.88,507.378,635.939,593.834,740.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M478.169,222.226c0,0,58.846-21.262,89.278,38.646c30.449,59.892,52.758,152.64-20.282,181.617 C526.865,386.461,478.169,222.226,478.169,222.226z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M683.064,727.415l105.582,198.093c0,0,60.871-44.45,36.527-88.88 c-24.35-44.44-52.691-100.048-52.691-100.048S743.819,693.025,683.064,727.415z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.d620c2a72ec399faf86420269b4d8dd9.svg";
export { ForwardRef as ReactComponent };